import { navigate } from 'gatsby';

import noExpired from '@/assets/icons/noExpired.svg';

import './no-expired-subsidies.scss';

type Props = {
  redirectURL: string;
};

const NoExpiredSubsidies = ({ redirectURL }: Props) => {
  return (
    <div className="no-expired-subsidies">
      <img src={noExpired} alt="noExpired image" />
      <h2>En este momento no tienes subsidios vencidos</h2>
      <p>Para obtener mayor información consulta tus pagos</p>

      <button onClick={() => navigate(redirectURL)}>Consultar pagos</button>
    </div>
  );
};

export default NoExpiredSubsidies;
